import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { EntityDataService } from '@ngrx/data';
import { SharedModule } from '../shared/shared.module';

import {
    PeriodContainerComponent,
    PeriodRoute,
    RecalculateTransactionsRoute
} from './recalculate-transactions.route';
import {
    entityName,
    RecalculateSchedulesDataService
} from '../data-services/recalculate-transactions/recalculate-schedules/recalculate-schedules.data-service';
import { SchedulesPresenterComponent } from './schedules-presenter/schedules-presenter.component';
import { RecalculateTransactionsFeatureComponent } from './recalculate-transactions-feature/recalculate-transactions-feature.component';
import { ContractsPresenterComponent } from './contracts-presenter/contracts-presenter.component';
import { SettingsPresenterComponent } from './settings-presenter/settings-presenter.component';
import { RecalculateTransactionsPresenterComponent } from './recalculate-transactions-presenter/recalculate-transactions-presenter.component';

@NgModule({
    declarations: [
        PeriodContainerComponent,
        SchedulesPresenterComponent,
        RecalculateTransactionsFeatureComponent,
        ContractsPresenterComponent,
        SettingsPresenterComponent,
        RecalculateTransactionsPresenterComponent
    ],
    providers: [RecalculateSchedulesDataService],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [PeriodRoute, RecalculateTransactionsRoute]
        })
    ]
})
export class RecalculateTransactionsModule {}
